// File helpers shared by the QC page and the sample tool dialogs on Home.

export const getFileTypeLabel = (fileDetails) => {
  if (fileDetails?.file_type === 'ont_bam') return 'ONT BAM'
  if (fileDetails?.file_type === 'pacbio_bam') return 'PacBio BAM'
  if (fileDetails?.file_type === 'fastq') return 'FASTQ'
  return 'VCF'
}

export const isSequenceFile = (fileDetails) =>
  fileDetails?.file_type === 'fastq' || fileDetails?.file_type === 'ont_bam' || fileDetails?.file_type === 'pacbio_bam'

export const getPrimaryFileId = (fileDetails) => {
  if (fileDetails?.file_type === 'ont_bam') return fileDetails.ont_bam_id
  if (fileDetails?.file_type === 'pacbio_bam') return fileDetails.pacbio_bam_id
  if (fileDetails?.file_type === 'fastq') return fileDetails.fastq_pair_id
  return fileDetails?.vcf_id
}
